export default __webpack_public_path__ + "static/media/kalahasthi.a40ae38f.png";